import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class Inventory {
  /* 盘点列表 */
  static getInventoryList(options) {
    let url = `/oa/api/inventory/import/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 录入 */
  static postEntryInventory(data) {
    let url = `/oa/api/inventory/import/save`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default Inventory;